<template>
  <div class="main">
    <div class="title">
      <div class="item" :class="activeIndex == index ? 'active' : ''" v-for="(item, index) in list" :key="index"
        @mouseenter="stopChange(index)" @mouseleave="startChange">
        {{ item.titleMain }}
      </div>
    </div>
    <div class="content">
      <transition enter-active-class="animate__animated animate__pulse" v-for="(item, index) in list" :key="index">
        <div class="boxFa" v-if="activeIndex == index">
          <div class="itemFa">
            <div class="testBoxs">
              <!-- class="swiper-no-swiping" 可复制-->
              <div  v-html="item.titleAssistant"></div>
              <div class="btnMore" v-if="item.link">
                <a :href="item.link" target="_blank">
                  <span>了解更多</span>
                  <img src="@/assets/img/ljgd.png" alt="">
                </a>
              </div>
            </div>
          </div>
          <div class="itemFa itemFa2">
            <img class="imgSrc" :src="item.imgUrl" />
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
var timeNum;
export default {
  name: "SolutionCity",
  props: ['list'],
  data() {
    return {
      titleArr: ["测绘服务", "数据服务", "数智应用"],
      englishTitleArr: [
        "Surveying And Mapping Service",
        "Data Service",
        "Intelligent Development Zone",
        "Intelligent Transportation",
        "Intelligent Policing",
      ],
      activeIndex: 0,
      interval_time: 3000, //自动切换间隔时间
    };
  },
  mounted() {
    // this.$wow.init();
    // this.autoIncrease();
  },

  methods: {
    autoIncrease() {
      timeNum = setInterval(() => {
        if (this.activeIndex < this.list.length - 1) {
          this.activeIndex++;
        } else {
          this.activeIndex = 0;
        }
      }, this.interval_time);
    },
    // changeActiveIndex(index) {
    //   this.activeIndex = index;
    //   clearInterval(timeNum);
    //   setTimeout(() => {
    //     this.autoIncrease();
    //   }, this.interval_time);
    // },
    stopChange(index) {
      this.activeIndex = index;
      clearInterval(timeNum);
    },
    startChange() {
      this.autoIncrease();
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  margin-left: 160px;

  .title {
    display: flex;
    font-size: 18px;

    width: 90%;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #fff;
    margin: 0 0 10px;
    border-radius: 10px;
    background-color: #004094;

    .item {
      margin: 0 10px;
      padding: 0 50px;
      line-height: 50px;
      cursor: pointer;
      border-radius: 10px;
      color: #fff;

      &:first-child {
        margin-left: 0;
      }
    }

    .active {
      color: #ffffff;
      background: #d7000f;
    }
  }

  .content {
    width: 1600px;
    height: 700px;
    position: relative;

    .boxFa {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 100%;

      .itemFa {
        margin-right: 18px;
        width: 37%;
        height: 500px;
        box-sizing: border-box;

        .testBoxs {
          .btnMore {
            width: 129px;
            height: 52px;
            background: #d7000f;
            border-radius: 6px;
            margin-top: 10px;
            a {
              display: flex;
              align-items: center;
              justify-content: center;
              height: 52px;
              font-size: 14px;
              color: #fff;
              text-decoration: none;
              img {
                width: 16px;
                margin-left: 10px;
              }
            }

          }
        }

        &:nth-child(2) {
          max-width: 100%;
          max-height: 100%;
          overflow: hidden;

          .imgSrc {
            width: 100%;
            // width: 1202px;
            // height: 352px;
            height: 100%;
            display: inline-block;
          }
        }

      }
      .itemFa2 {
        width: 47%;
        &:nth-child(2) {
          .imgSrc {
            // height: auto;
            height: 400px;
          }
        }
      }
    }
  }
}

.flexCenter {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}
</style>
